/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { DateFormatOptions } from "./DateFormatOptions";
import { defaultLocale, defaultTimezone } from "./constants";

/**
 * Converts given UTC date time to the local weekday using the provided options.
 * @example "Fri" (for Friday using "en-US" locale).
 * @param date The date-time to convert.
 * @param options The options for formatting the date.
 * @returns The formatted local weekday.
 */
export const toLocalWeekday = (date: Date, options: DateFormatOptions): string => {
    const { locale, timeZone } = options;

    return Intl.DateTimeFormat(locale ? locale : defaultLocale, {
        timeZone: timeZone ? timeZone : defaultTimezone,
        weekday: "short"
    }).format(date);
};
